import { Chip, SxProps, Theme, useTheme } from "@mui/material";
import { ComponentProps } from "react";

type CustomChipType = {
    children: string;
    variant?: ComponentProps<typeof Chip>["variant"];
    sx?: SxProps<Theme>;
};

function CustomChip({ children, variant = "outlined", sx = {} }: CustomChipType) {
    const theme = useTheme();

    return (
        <Chip
            label={children}
            variant={variant}
            sx={{
                fontFamily: "monospace",
                height: 24,
                fontSize: "0.75rem",
                backgroundColor: theme.palette.cardBackground,
                borderColor: theme.palette.borderColor,
                color: theme.palette.text.primary,
                ...sx
            }}
        />
    );
}

export default CustomChip;
